.menu-item-root {
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
  display: flex;
  gap: 8px;
  align-items: center;
}

.menu-item-root:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.menu-item-label {
  font-size: 14px;
}

.menu-item-root[disabled] {
  pointer-events: none;
  opacity: 0.4;
}

.menu-icon {
  height: 100%;
  text-align: center;
}

.menu-icon[disabled] {
  opacity: 0.4;
}
